<template>
	<div :class="{'row m-0' : small}">
		<div v-if="withOption">
			<SOInputSelect
				:title="'Berdasarkan'"
				:options="optionData"
				:selected="optionSelected"
				@option-selected="applySelectedOption"
			/>
			<hr>
		</div>
		<div :class="{'row m-0': small}" v-if="!limitLoop">
			<div class="custom-control custom-checkbox remove-padding m-t-8"
			     :class="{'col-md-6 col-sm-6 col-6 p-0': small}"
			     v-for="(checkbox, idx) in checkboxes.data" :key="`chk1${idx}`">
				<input class="custom-control-input"
				       type="checkbox"
				       :id="checkbox.id"
				       :name="checkboxes.name"
				       :value="checkbox.value"
				       :checked="checkbox.checked"
				       :disabled="(checkbox.disabled === undefined) ? false : checkbox.disabled"
				       v-model="checked"
				       @click="expandChild(checkbox)"
				/>
				<label
					class="custom-control-label label-checklist"
					:for="checkbox.id"
					:class="{'text-bold': checkbox.titleBold}"
					v-html="(checkbox.disabled === undefined) ? checkbox.title : (checkbox.disabled) ? `<span class='f-c-midgrey'>` + checkbox.title + `</span>` : checkbox.title"
				>
				</label>
				<div :id="`child-${checkbox.id}`"
				     v-if="checkbox.child !== undefined"
				>
					<div class="m-l-20 m-t-8"
					     :class="{
							'checkbox_child_hide' : checked.length === 0 ?
							true :
							!checked.includes(checkbox.value)
						}"
					     v-if="checkbox.child.data.length > 0"
					     v-for="(checkboxChild, idxc) in checkbox.child.data"
					     :key="`chk1${idxc}`"
					>
						<input class="custom-control-input"
						       type="checkbox"
						       :id="checkboxChild.id"
						       :name="checkbox.child.name"
						       :value="checkboxChild.value"
						       :checked="checkboxChild.checked"
						       :disabled="(checkbox.disabled === undefined) ? false : checkbox.disabled"
						       v-model="checkedChild"
						/>
						<label
							class="custom-control-label label-checklist"
							:for="checkboxChild.id"
							:class="{'text-bold': checkboxChild.titleBold}"
							v-html="checkboxChild.title"
						>
						</label>
					</div>
				</div>

			</div>
		</div>
		<div v-else>
			<div
				class="custom-control custom-checkbox remove-padding m-t-8 check_all"
				:class="{'col-md-6 col-sm-6 col-6 p-0': small}"
				v-if="useCheckAll && checkboxes.data.length > 0"
			>
				<input
					class="custom-control-input"
					type="checkbox"
					:id="`check_all${modalId}`"
					:name="`Pilih Semua`"
					:value="`checkAll`"
					:checked="checkAll"
					@click="handleCheckAll"
				/>
				<label class="custom-control-label label-checklist text-bold" :for="`check_all${modalId}`">
					Pilih Semua
				</label>
			</div>
			<div class="custom-control custom-checkbox remove-padding m-t-8"
			     :class="{'col-md-6 col-sm-6 col-6 p-0': small}"
			     v-for="(checkbox, idx) in checkboxes.data.slice(0, limitLoopCount)" :key="`chk2${idx}`">
				<input class="custom-control-input"
				       type="checkbox"
				       :id="checkbox.id"
				       :name="checkboxes.name"
				       :value="checkbox.value"
				       :checked="checkbox.checked"
				       :disabled="(checkbox.disabled === undefined) ? false : checkbox.disabled"
				       v-model="checked"
				/>
				<label
					class="custom-control-label label-checklist"
					:for="checkbox.id"
					:class="{'text-bold': checkbox.titleBold}"
					v-html="(checkbox.disabled === undefined) ? checkbox.title : (checkbox.disabled) ? `<span class='f-c-midgrey'>` + checkbox.title + `</span>` : checkbox.title"
				>
				</label>
			</div>
			<div class="m-t-16"
			     v-if="checkboxes.data.length > limitLoopCount"
			     @click="showModal"
			>
				<span class="f-regular f-16 f-c-blue" :id="'text-' + moreCheckbox">Pilihan lainnya</span>
				<img src="../../../assets/icons/chevron-rotate-down.svg"
				     class="m-l-4"
				     style="margin-top: -2px"
				     alt=""
				     :id="'chev-' + moreCheckbox"
				>
			</div>
		</div>
		<SOSlotModal
			v-if="limitLoop"
			:modal-title="modalTitle"
			:modal-id="modalId"
			:force-bg="true"
			@close="closeModal"
		>
			<template v-slot:modal-body>
				<div style="position: relative" class="m-d-16">
					<input v-model="search" @keyup="($event) => search = $event.target.value" type="text" class="form-control" style="padding-left: 36px"
					       autocomplete="off">
					<i class="fas fa-search f-c-midgrey" style="position: absolute; top: 10px; left: 12px"></i>
				</div>
				<div style="height: 300px; overflow: auto">
					<div class="custom-control custom-checkbox remove-padding m-t-8"
					     :class="{'col-md-6 col-sm-6 col-6 p-0': small}"
					     v-for="(checkbox, idx) in filteredData"
					     :key="`chk3${idx}`">
						<input class="custom-control-input"
						       type="checkbox"
						       :id="'clone-' + checkbox.id"
						       :name="checkboxes.name"
						       :value="checkbox.value"
						       :checked="checkbox.checked"
						       :disabled="(checkbox.disabled === undefined) ? false : checkbox.disabled"
						       v-model="clone.checked"
						/>
						<label
							class="custom-control-label label-checklist"
							:for="'clone-' + checkbox.id"
							:class="{'text-bold': checkbox.titleBold}"
							v-html="(checkbox.disabled === undefined) ? searchHighlight(checkbox.title,search) : (checkbox.disabled) ? `<span class='f-c-midgrey'>` + searchHighlight(checkbox.title,search) + `</span>` : searchHighlight(checkbox.title,search)"
						>
						</label>
					</div>
				</div>
			</template>
			<template v-slot:modal-footer>
				<SOButton
					:text="'Terapkan'"
					:primary="true"
					:full="true"
					@action="apply"
				/>
			</template>
		</SOSlotModal>
	</div>
</template>

<script>
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";

import { regex } from "@/store/utils/vars";

export default {
	name: "SOInputCheckbox",
	// props: ["checkboxes", "small"],
	components: {
		SOInputSelect,
		SOButton,
		SOSlotModal
	},
	props: {
		checkboxes: Object,
		small: Boolean,
		checked: Array,
		checkedChild: Array,
		limitLoop: Boolean,
		limitLoopCount: Number,
		useCheckAll: {
			type: Boolean,
			default: false
		},
		// modal
		modalTitle: String,
		modalId: String,

		// select-option
		withOption: {
			type: Boolean,
			default: false,
		},
		optionData: {
			type: Array,
			default: function() {
        return []
      },
		},
		optionSelected: {
			type: String,
			default: ""
		},
	},
    computed: {
        filteredData() {
            return this.clone.checkboxes.data.filter(obj => obj.title.toLowerCase().indexOf(this.search.toLowerCase()) !== -1)
        }
    },
	data() {
		return {
			moreCheckbox: "more-checkbox",
			search: "",
			checkAll: false,
			defaultCheckbox: {},
			clone: {
				checkboxes: {
					data: []
				},
				checked: [],
			}
		}
	},
	mounted() {
		this.clone.checkboxes = this.checkboxes
		this.defaultCheckbox = this.checkboxes
	},
	methods: {
		showModal() {
			$("#modal-filter").animate({scrollTop: 0}, "fast");
			$("#modal-filter").css({"overflow": "hidden"})
			$("#" + this.modalId).modal("show")

			this.clone.checked = this.checked
			this.search = ""
		},
		closeModal() {
			$("#modal-filter").css({"overflow": "auto"})
			$("#" + this.modalId).modal("hide")

			this.clone.checked = this.checked
			this.search = ""
		},
		apply() {
			this.checked = this.clone.checked
			this.closeModal()
		},
		reorderOption(selected) {
			setTimeout(() => {
				let reorder = []
				for (let i = 0; i < this.defaultCheckbox.data.length; i++) {
					if (selected.includes(this.defaultCheckbox.data[i].value)) {
						reorder = [...reorder, this.defaultCheckbox.data[i]]
					}
				}
				for (let i = 0; i < this.defaultCheckbox.data.length; i++) {
					if (!selected.includes(this.defaultCheckbox.data[i].value)) {
						reorder = [...reorder, this.defaultCheckbox.data[i]]
					}
				}

				this.clone.checkboxes.data = reorder
				this.checkboxes = this.clone.checkboxes
			}, 100)
			this.checkAll = selected.length === this.defaultCheckbox.data.length
		},
		handleCheckAll(e) {
			let checList = e.target.checked ? "checkAll" : "unCheckAll";

			this.$emit("selected", checList)
		},
		expandChild(checkbox) {
			if (checkbox.child !== undefined) {
				if ($("#" + checkbox.id).prop("checked")) {
					$("#child-" + checkbox.id).slideDown(300);
				} else {
					$("#child-" + checkbox.id).slideUp(300);
					this.checkedChild = [];
				}
			}
		},
		applySelectedOption(val) {
			// let temp = this.filterItem
			// temp[this.filterGlobalKey] = val
			// this.$store.commit("filterGlobalModule/setFilterItem", temp)
			//
			// this.setDiterapkan()
		}
	},
	watch: {
		"clone.checked": {
			handler: function () {
				this.reorderOption(this.clone.checked)
			},
			deep: true
		},
		checked: {
			handler: function () {
				if (this.limitLoop) {
					this.reorderOption(this.checked)
				}

        // console.log("woy", this.checked)
				this.$emit("selected", this.checked)
			},
			deep: true
		},
		checkedChild: {
			handler: function () {
				this.$emit("selected-child", this.checkedChild)
			},
			deep: true
		},
		checkboxes: {
			handler: function (v) {
				this.defaultCheckbox = JSON.parse(JSON.stringify(v))
				this.reorderOption(this.checked)
			},
			deep: true
		},
		search: {
			handler: function () {
				this.search = this.search.replace(regex.alphanumeric, "")
			},
		}
	}
}
</script>

<style scoped>
.text-bold {
	font-weight: bold;
}

.check_all {
	border-bottom: 2px solid #EDEDED;
	padding-bottom: 8px;
}

.checkbox_child_hide {
	display: none;
}
</style>